/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as PendingApprovalRouteImport } from './routes/pending-approval'
import { Route as AppAccountsRouteImport } from './routes/_app/accounts'
import { Route as AppBudgetsRouteImport } from './routes/_app/budgets'
import { Route as AppCardsRouteImport } from './routes/_app/cards'
import { Route as AppCategoriesRouteImport } from './routes/_app/categories'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppIncomeRouteImport } from './routes/_app/income'
import { Route as AppIouRouteImport } from './routes/_app/iou'
import { Route as AppProvisionsRouteImport } from './routes/_app/provisions'
import { Route as AppRecurringRouteImport } from './routes/_app/recurring'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppTransactionsRouteImport } from './routes/_app/transactions'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const PendingApprovalRoute = PendingApprovalRouteImport.update({
  id: '/pending-approval',
  path: '/pending-approval',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAccountsRoute = AppAccountsRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => AppRoute,
} as any)
const AppBudgetsRoute = AppBudgetsRouteImport.update({
  id: '/budgets',
  path: '/budgets',
  getParentRoute: () => AppRoute,
} as any)
const AppCardsRoute = AppCardsRouteImport.update({
  id: '/cards',
  path: '/cards',
  getParentRoute: () => AppRoute,
} as any)
const AppCategoriesRoute = AppCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppIncomeRoute = AppIncomeRouteImport.update({
  id: '/income',
  path: '/income',
  getParentRoute: () => AppRoute,
} as any)
const AppIouRoute = AppIouRouteImport.update({
  id: '/iou',
  path: '/iou',
  getParentRoute: () => AppRoute,
} as any)
const AppProvisionsRoute = AppProvisionsRouteImport.update({
  id: '/provisions',
  path: '/provisions',
  getParentRoute: () => AppRoute,
} as any)
const AppRecurringRoute = AppRecurringRouteImport.update({
  id: '/recurring',
  path: '/recurring',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppTransactionsRoute = AppTransactionsRouteImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/auth': typeof AuthRoute
  '/pending-approval': typeof PendingApprovalRoute
  '/accounts': typeof AppAccountsRoute
  '/budgets': typeof AppBudgetsRoute
  '/cards': typeof AppCardsRoute
  '/categories': typeof AppCategoriesRoute
  '/dashboard': typeof AppDashboardRoute
  '/income': typeof AppIncomeRoute
  '/iou': typeof AppIouRoute
  '/provisions': typeof AppProvisionsRoute
  '/recurring': typeof AppRecurringRoute
  '/settings': typeof AppSettingsRoute
  '/transactions': typeof AppTransactionsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/auth': typeof AuthRoute
  '/pending-approval': typeof PendingApprovalRoute
  '/accounts': typeof AppAccountsRoute
  '/budgets': typeof AppBudgetsRoute
  '/cards': typeof AppCardsRoute
  '/categories': typeof AppCategoriesRoute
  '/dashboard': typeof AppDashboardRoute
  '/income': typeof AppIncomeRoute
  '/iou': typeof AppIouRoute
  '/provisions': typeof AppProvisionsRoute
  '/recurring': typeof AppRecurringRoute
  '/settings': typeof AppSettingsRoute
  '/transactions': typeof AppTransactionsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/admin': typeof AdminRoute
  '/auth': typeof AuthRoute
  '/pending-approval': typeof PendingApprovalRoute
  '/_app/accounts': typeof AppAccountsRoute
  '/_app/budgets': typeof AppBudgetsRoute
  '/_app/cards': typeof AppCardsRoute
  '/_app/categories': typeof AppCategoriesRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/income': typeof AppIncomeRoute
  '/_app/iou': typeof AppIouRoute
  '/_app/provisions': typeof AppProvisionsRoute
  '/_app/recurring': typeof AppRecurringRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/transactions': typeof AppTransactionsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/auth'
    | '/pending-approval'
    | '/accounts'
    | '/budgets'
    | '/cards'
    | '/categories'
    | '/dashboard'
    | '/income'
    | '/iou'
    | '/provisions'
    | '/recurring'
    | '/settings'
    | '/transactions'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/auth'
    | '/pending-approval'
    | '/accounts'
    | '/budgets'
    | '/cards'
    | '/categories'
    | '/dashboard'
    | '/income'
    | '/iou'
    | '/provisions'
    | '/recurring'
    | '/settings'
    | '/transactions'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/admin'
    | '/auth'
    | '/pending-approval'
    | '/_app/accounts'
    | '/_app/budgets'
    | '/_app/cards'
    | '/_app/categories'
    | '/_app/dashboard'
    | '/_app/income'
    | '/_app/iou'
    | '/_app/provisions'
    | '/_app/recurring'
    | '/_app/settings'
    | '/_app/transactions'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  AdminRoute: typeof AdminRoute
  AuthRoute: typeof AuthRoute
  PendingApprovalRoute: typeof PendingApprovalRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pending-approval': {
      id: '/pending-approval'
      path: '/pending-approval'
      fullPath: '/pending-approval'
      preLoaderRoute: typeof PendingApprovalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/accounts': {
      id: '/_app/accounts'
      path: '/accounts'
      fullPath: '/accounts'
      preLoaderRoute: typeof AppAccountsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/budgets': {
      id: '/_app/budgets'
      path: '/budgets'
      fullPath: '/budgets'
      preLoaderRoute: typeof AppBudgetsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cards': {
      id: '/_app/cards'
      path: '/cards'
      fullPath: '/cards'
      preLoaderRoute: typeof AppCardsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/categories': {
      id: '/_app/categories'
      path: '/categories'
      fullPath: '/categories'
      preLoaderRoute: typeof AppCategoriesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/income': {
      id: '/_app/income'
      path: '/income'
      fullPath: '/income'
      preLoaderRoute: typeof AppIncomeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/iou': {
      id: '/_app/iou'
      path: '/iou'
      fullPath: '/iou'
      preLoaderRoute: typeof AppIouRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/provisions': {
      id: '/_app/provisions'
      path: '/provisions'
      fullPath: '/provisions'
      preLoaderRoute: typeof AppProvisionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/recurring': {
      id: '/_app/recurring'
      path: '/recurring'
      fullPath: '/recurring'
      preLoaderRoute: typeof AppRecurringRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/transactions': {
      id: '/_app/transactions'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof AppTransactionsRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAccountsRoute: typeof AppAccountsRoute
  AppBudgetsRoute: typeof AppBudgetsRoute
  AppCardsRoute: typeof AppCardsRoute
  AppCategoriesRoute: typeof AppCategoriesRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppIncomeRoute: typeof AppIncomeRoute
  AppIouRoute: typeof AppIouRoute
  AppProvisionsRoute: typeof AppProvisionsRoute
  AppRecurringRoute: typeof AppRecurringRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppTransactionsRoute: typeof AppTransactionsRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountsRoute: AppAccountsRoute,
  AppBudgetsRoute: AppBudgetsRoute,
  AppCardsRoute: AppCardsRoute,
  AppCategoriesRoute: AppCategoriesRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppIncomeRoute: AppIncomeRoute,
  AppIouRoute: AppIouRoute,
  AppProvisionsRoute: AppProvisionsRoute,
  AppRecurringRoute: AppRecurringRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppTransactionsRoute: AppTransactionsRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AdminRoute: AdminRoute,
  AuthRoute: AuthRoute,
  PendingApprovalRoute: PendingApprovalRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
